import ErrorBoundary from "@Components/ErrorBoundary";
import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import { loadCustomPaymentData } from "@Pages/BookForm/data/leadCustomPaymentData";
import NotFound from "@Pages/NotFound";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import useCustomPaymentPage from "./useCustomPaymentPage";

const CustomPaymentWrapper = loadable(() => import("./CustomPaymentWrapper"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isError, isLoading } = useCustomPaymentPage();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadCustomPaymentData(props));
  }, []);

  if (isError) {
    return <NotFound isStatus500 {...props} />;
  }

  if (isLoading) {
    return <FullPageLoader />;
  }

  return (
    <ErrorBoundary>
      <CustomPaymentWrapper {...props} />
    </ErrorBoundary>
  );
};
